import {
  Directive,
  Input,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy, Renderer2, AfterViewInit,
} from "@angular/core";
import { createPopper, Instance as PopperInstance, Placement } from "@popperjs/core";
import { filter } from "rxjs/operators";
import { fromEvent, merge, pluck, Subject, takeUntil } from "rxjs";

import { MedTooltipService } from "../services/med-tooltip.service";

@Directive({
  selector: "[medTooltip]",
})
export class MedTooltipDirective implements AfterViewInit, OnDestroy {
  constructor(
    private medTooltip: MedTooltipService,
    private el: ElementRef,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
  ) {}

  private _popperInstance?: PopperInstance;
  private _destroy$ = new Subject<void>();

  @Input() placement: Placement = "top";
  @Input("medTooltip") componentKey = "";

  ngAfterViewInit() {
    this._popperInstance = createPopper(this.el.nativeElement, this.medTooltip.tooltipContentEl, {
      strategy: "fixed",
      placement: this.placement,
    });

    this.renderer.setStyle(this.medTooltip.tooltipContentEl, "display", "none");

    merge(
      fromEvent(this.el.nativeElement, "mouseenter"),
      fromEvent(this.el.nativeElement, "mouseleave"),
    )
      .pipe(
        filter(() => this._popperInstance !== null),
        pluck("type"),
        takeUntil(this._destroy$),
      )
      .subscribe((e: any) => this._mouseHoverHandler(e));

    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this._popperInstance?.destroy();
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _mouseHoverHandler(e: string): void {
    if (e === "mouseenter") {
      this.renderer.removeStyle(this.medTooltip.tooltipContentEl, "display");
      this._updatePopper(true);
      this.medTooltip.show(this.componentKey);
    } else {
      this.renderer.setStyle(this.medTooltip.tooltipContentEl, "display", "none");
      this._updatePopper(false);
    }
  }

  private _updatePopper(enabled: boolean): void {
    // Enable the event listeners
    this._popperInstance?.setOptions(options => ({
      ...options,
      modifiers: [
        ...(options.modifiers || []),
        { name: "eventListeners", enabled },
      ],
    }));

    this._popperInstance?.update();
  }
}
